// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__36ZZ0","errorLogs":"styles_errorLogs__2lB7L"};